import React from 'react';

const RodoClauseModalBody = () => {
    return(
        <div className="col-xs-12">
            <strong>Zgodnie z art. 13 ust. 1 i ust. 2 ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r. informuję, iż:</strong>
            <ol>
                <li>administratorem Pani/Pana danych osobowych jest PRO sp. z o.o. z siedzibą w Bielsko-Biała ul. Strażacka 76;</li>
                <li>kontakt z powołanym przez PRO sp. z o.o. inspektorem ochrony danych pod adresem e-mail: iod@poziomnica.pl;</li>
                <li>Pani/Pana dane osobowe przetwarzane będą w celu:</li>
                <ul>
                    <li>w celach wynikających z prawnie uzasadnionych interesów realizowanych przez PRO sp. z o.o. jako administratora danych (podstawa prawna art. 6 ust. 1 lit. f RODO);</li>
                    <li>w celu wykonywania umów zawieranych przez PRO sp. z o.o. z klientami (podstawa prawna art. 6 ust. 1 lit. b RODO);</li>
                    <li>w celu prowadzenia rekrutacji osób zainteresowanych pracą PRO sp. z o.o. (podstawa prawna art. 6 ust. 1 lit. a RODO).</li>
                </ul>
                Przetwarzamy dane osobowe również w zakresie wypełnienia obowiązków prawnych ciążących na PRO sp. z o.o. (podstawa prawna art. 6 ust. 1 lit. c RODO).
                <li>Pani/Pana dane osobowe będą przechowywane do momentu wycofania zgody/zakończenia współpracy;</li>
                <li>posiada Pani/Pan prawo dostępu do treści swoich danych oraz prawo ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo wniesienia sprzeciwu, prawo do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania , którego dokonano na podstawie zgody przed jej cofnięciem;</li>
                <li>ma Pani/Pan prawo wniesienia skargi do PUODO gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r.</li>
            </ol>
        </div>
    );
};

// DO ZMIANY

export default RodoClauseModalBody;


// WEBPACK FOOTER //
// ./src/components/RodoClause/RodoClauseModalBody.js